
export const GlassContainerSVG = ({
  fillColor = '#4acb5c',
  borderColor = '#048658',
  contrastColor = '#8ab8a8',
  width = 33.506,
  height = 40
}) => {
  const viewBox = '0 0 40 40';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
    >
      <g id="glass-container" transform="translate(4 0.5)">
        <path
          id="bloque"
          data-name="bloque"
          d="M22.652,37.406V14.554a14.487,14.487,0,1,1,28.974,0V37.242"
          transform="translate(-20.886)"
          fill={fillColor}
          stroke={borderColor}
          strokeWidth="1"
        />
        <path
          id="base"
          data-name="base"
          d="M31.268,480.32H1.238A1.238,1.238,0,0,1,0,479.083v-.029a1.238,1.238,0,0,1,1.238-1.238h30.03a1.238,1.238,0,0,1,1.238,1.238v.029A1.238,1.238,0,0,1,31.268,480.32Zm0,0"
          transform="translate(0 -440.566)"
          fill={contrastColor}
          stroke={borderColor}
          strokeWidth="1"
        />
        <path
          id="entrada"
          data-name="entrada"
          d="M31.851,45.7a4.721,4.721,0,0,0,4.6-4.833,4.9,4.9,0,0,0-2.012-4l-.041-.036a14.571,14.571,0,0,0-5.348,7.886l.131.083A4.431,4.431,0,0,0,31.851,45.7Zm0,0"
          transform="translate(-26.786 -33.961)"
          fill={contrastColor}
          stroke={borderColor}
          strokeWidth="1"
        />
      </g>
    </svg>
  );
};